var app = angular.module("leonardo");

var OnDemandInstructionController = function($scope, $state, ngDialog, instructionObj, AccountUserService,
                                             OnDemandInstructionService, OnDemandCategoryService, $q, AuthDataService,
                                             NotificationService, AttachmentService, FilterService, FormErrorsService,
                                             AccountService, FileService, OnDemandSubCategoryService, $timeout, ClientInstanceService) {

  $scope.create = $state.current.action === 'create' ;
  $scope.categories = [];
  $scope.subcategories = [];
  $scope.old_attachments = [];
  $scope.files = [];
  $scope.teaserMaxLength = 200;
  $scope.users = [];
  $scope.onDemandCategoryService = OnDemandCategoryService;
  $scope.onDemandSubCategoryService = OnDemandSubCategoryService;
  $scope.accountUserService = AccountUserService;
  $scope.authDataService = AuthDataService;
  $scope.clientInstanceService = ClientInstanceService;
  $scope.attachmentService = AttachmentService;
  $scope.errorSize = false;

  $scope.instruction = instructionObj;

  if ($scope.create) {
    $scope.instruction.client_instance = AuthDataService.getClientInstance();
    if ((AccountService.getCollection().length > 1) && AuthDataService.isNotStaff()) {
      ngDialog.openConfirm({
        template: 'views/templates/dialog/account/select.html',
        controller: 'SelectAccountDialog',
        className: 'ngdialog-theme-default ngdialog-select-account',
        data: {
          permission: 'permission_add_on_demand_instruction'
        }
      }).then(function (account) {
        if (!account){
          window.history.back();
        }
        $scope.instruction.account = (account !== 'all') ? account : null;
      }, function() {
        window.history.back();
      });
    }
    else if (AuthDataService.isNotStaff()) {
      $scope.instruction.account = (instructionObj && instructionObj.account) ? instructionObj.account : AccountUserService.currentAccountUser.account;
    }
  }
  else {
    $scope.instruction.client_instance = ($scope.instruction.client_instance && $scope.instruction.client_instance.id) ? $scope.instruction.client_instance.id : $scope.instruction.client_instance;
    if (instructionObj.subcategories && (instructionObj.subcategories.length > 0)) {
      var subcategories = [];
      angular.forEach(instructionObj.subcategories, function(subcategory) {
        subcategories.push(subcategory.id ? subcategory.id : subcategory);
      });
      $scope.instruction.subcategories = subcategories;
    }

    angular.forEach($scope.instruction.attachments, function(attatchment){
      if (attatchment.document_file) {
        attatchment.file = attatchment.document_file.signed_view_url;
      }
      else if (attatchment.link) {
        attatchment.file = attatchment.link;
      }
      $scope.old_attachments.push(attatchment);
    });
  }

  $scope.getData = function(){
    var data = {
      id: $scope.instruction.id,
      name: $scope.instruction.name,
      category: $scope.instruction.category,
      subcategories: !isEmpty($scope.instruction.subcategories) ? $scope.instruction.subcategories : [],
      //white_label: AuthDataService.getWhiteLabel(),
      client_instance: AuthDataService.getClientInstance(),
      account: $scope.instruction.account,
      body: $scope.instruction.body,
      teaser: $scope.instruction.teaser,
      attachments: [],
      notify_user: $scope.instruction.notify_user
    };
    if (angular.isArray($scope.instruction.available_for_account_users)) {
      data['available_for_account_users'] = $scope.instruction.available_for_account_users;
    }
    else {
      data['available_for_account_users'] = $scope.instruction.available_for_account_users ? $scope.instruction.available_for_account_users.split(',') : [];
    }
    angular.forEach($scope.old_attachments, function(attachment) {
      data['attachments'].push(attachment.id);
    });
    return data;
  };

  $scope.getSector = function() {
    if ((AuthDataService.isAdmin() || AuthDataService.isWhiteLabelAdmin())) {
      return FilterService.hasFilter('sector') ? FilterService.getFilter('sector') : null;
    }
    return null;
  };

  $scope.showDocManager = function() {
    $scope.errorSize = false;
    ngDialog.openConfirm({
      template: 'views/templates/dialog/folder/selector.html',
      controller: 'FolderSelectorDialog',
      data: {
        sector: $scope.getSector(),
        mode_folder: 'files',
        action: 'select',
        account: $scope.instruction.account
      }
    }).then(function(file) {
      if (file){
        if (file.document_file) {
          var array_url = file.destiny.file.split('/');
          var array_filename = array_url[array_url.length - 1].split('.');
          var file_aux = new FileService([file.destiny.file], array_url[array_url.length - 1], {
            type: $scope.getClassesAttachment(file.destiny) +'/' + array_filename[array_filename.length-1],
            lastModified: new Date()
          });
          var fd = new FormData();
          fd.append('file', file_aux);
          file_aux.file = fd;
          file_aux.name = file.destiny.name;
          file_aux.document_file = file.destiny.id;
          $scope.files.push(file_aux);
        }
        else {
          var file_new = {
            name: file.destiny.name,
            document_folder: file.destiny.id
          };
          $scope.files.push(file_new);
        }
      }
    }, function () {
      return;
    });
  };

  $scope.onFileUpload = function(files) {
    if (!files) {
      return;
    }
    $scope.errorSize = AttachmentService.checkErrorSize(files);
    if ($scope.errorSize) {
      return;
    }
    angular.forEach(files, function (file) {
      var fd = new FormData();
      fd.append('file', file);
      var file_aux = file;
      file_aux.file = fd;
      $scope.files.push(file_aux);
    });
  };

  $scope.addLink = function() {
    if (!$scope.link) {
      return;
    }
    $scope.errorSize = false;
    if (!$scope.link.startsWith("https")) {
      $scope.link = 'https://' + $scope.link;
    }
    var name = $scope.link.substring(0, 255);
    var attachment = {
      link: $scope.link,
      name: name
    };
    $scope.files.push(attachment);
    $scope.link = '';
  };

  $scope.removeFile = function(index, old) {
    $scope.errorSize = false;
    if(old) {
      $scope.old_attachments.splice(index, 1);
    }
    else {
      $scope.files.splice(index, 1);
    }
  };

  $scope.submit = function() {
    $scope.Form.$setSubmitted();
    if ($scope.Form.$invalid) {
      FormErrorsService.goToError();
      return;
    }
    var data = $scope.getData();
    ngDialog.openConfirm({
      template: 'views/templates/dialog/on-demand-instructions/warning.html',
      controller: 'OnDemandWarningDialog',
      data: {
        instruction: data,
        create: $scope.create,
        notify: $scope.instruction.notify_user
      }
    }).then(function() {
      var promises = [];
      angular.forEach($scope.files, function(attachment) {
        if (attachment.document_folder || attachment.document_file) {
          promises.push(AttachmentService.linkTo(attachment).then(function(response){
            data['attachments'].push(response.data.id);
          }));
        }
        else if (attachment.link) {
          promises.push(AttachmentService.post(attachment.name, null, attachment.link, attachment.available_for_account).then(function(response){
            data['attachments'].push(response.data.id);
          }));
        }
        else {
          promises.push(AttachmentService.post(attachment.name, attachment, null, attachment.available_for_account).then(function(response){
            data['attachments'].push(response.data.id);
          }));
        }
      });
      $q.all(promises).then(function() {
        if ($scope.create) {
          OnDemandInstructionService.post(data).then(function(){
            timeout();
          });
        }
        else {
          $scope.instruction.patch(data).then(function() {
            timeout();
          });
        }
      });
    }, function () {
      return;
    });
  };

  function timeout(){
    $timeout(function () {
      $state.go('on-demand-instructions');
    }, 100);
  }

  $scope.showOnDemandDeleteDialog = function() {
    ngDialog.openConfirm({
      template: 'views/templates/dialog/on-demand-instructions/delete.html',
      controller: 'OnDemandDeleteDialog',
      data: {
        item: $scope.instruction,
        type: 'instruction'
      }
    }).then(function() {
      OnDemandInstructionService.updateCollection($scope.instruction, true);
    }, function () {
      return;
    });
  };

  $scope.$on('on-demand-instruction:updated', function () {
    $state.go('on-demand-instructions.instructions');
  });

  $scope.$watch('instruction.name.length', function(newValue){
    $scope.teaserMaxLength = parseInt(140 - (newValue * 1.25));
  });
};

app.controller('OnDemandInstructionController', ['$scope', '$state', 'ngDialog', 'instructionObj',
  'AccountUserService', 'OnDemandInstructionService', 'OnDemandCategoryService', '$q', 'AuthDataService',
  'NotificationService', 'AttachmentService', 'FilterService', 'FormErrorsService', 'AccountService',
  'FileService', 'OnDemandSubCategoryService', '$timeout', 'ClientInstanceService', OnDemandInstructionController]);
